export enum Environment {
    DEVELOPMENT = "DEVELOPMENT",
    PRODUCTION = "PRODUCTION"
}